// extracted by mini-css-extract-plugin
export default {"block":"kcGD8thD","row":"HQysC3Gy","dot":"JjJpeNXQ","title":"_aL8Klb9","body":"F49H05hP"};